import { useEffect, useContext } from 'react';
import AuthenticationContext from '@artemis/integrations/auth/AuthenticationContext';

const useAuthWithLogin = modalParams => {
  const authData = useContext(AuthenticationContext);
  const { authenticated, initialized, setAuthModal } = authData;

  useEffect(() => {
    // If not authenticated, show login modal
    if (!authenticated && initialized) {
      setAuthModal({
        // Default to not closeable for pages where users must log in
        closeable: false,
        ...modalParams,
        showLoginModal: true,
      });
    }
  }, [authenticated, initialized]);

  return { ...authData };
};

export default useAuthWithLogin;
